export default __webpack_public_path__ + "0bcf268d28b6f58c412627ff99a08bae.png";